import{jsxs as e,jsx as o}from"react/jsx-runtime";import{MdArrowBack as r}from"../../../../node_modules/@react-icons/all-files/md/MdArrowBack.js";import{MdMoreVert as i}from"../../../../node_modules/@react-icons/all-files/md/MdMoreVert.js";import{MdPerson as t}from"../../../../node_modules/@react-icons/all-files/md/MdPerson.js";import{MdPhone as s}from"../../../../node_modules/@react-icons/all-files/md/MdPhone.js";import{MdVideocam as n}from"../../../../node_modules/@react-icons/all-files/md/MdVideocam.js";import d from"styled-components";import{useTranslation as a}from"react-i18next";import{withTranslations as l}from"../../../../services/translations/withTranslations.js";import{RobotoFontStyle as m}from"../../../../style/fonts/robotoFont.js";const p=d.div`
  ${m}
  display: flex;
  height: 55px;
  background: #005e54;
  color: #fff;
  padding: 0 8px;
  font-size: 24px;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  z-index: 1;
  box-shadow: 0 -4px 10px 0 #000000;
`,c=d.div`
  margin-left: 8px;
  width: 110px;
`,f=d.div`
  font-size: 17px;
  font-weight: 600;
  text-overflow: ellipsis;
  letter-spacing: 0.3px;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`,x=d.div`
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
`,h=d(n)`
  margin-left: auto;
`,w=d(s)`
  margin-left: 15px;
`,g=d(i)`
  margin-left: 10px;
`,u=d(t)`
  border-radius: 50%;
  background: #d9e0e7;
`,M=l((()=>{const{t:i}=a();return e(p,{children:[o(r,{}),o(u,{}),e(c,{children:[o(f,{children:i("whatsapp.userName")}),o(x,{children:i("common.online")})]}),o(h,{}),o(w,{}),o(g,{})]})}));export{M as TopBar};
//# sourceMappingURL=TopBar.js.map
